import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportEmployeeRequestSlice = createSlice({
  name: "exportEmployeeRequest",
  initialState,
  reducers: {
    exportEmployeeRequestStart: (state, action: { payload: string }) => {
      state.status = ReduxStateType.LOADING;
    },
    exportEmployeeRequestSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportEmployeeRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportEmployeeRequestStart,
  exportEmployeeRequestSuccess,
  exportEmployeeRequestFailed,
} = exportEmployeeRequestSlice.actions;

export default exportEmployeeRequestSlice.reducer;
